<template>
  <div class="flex items-start gap-3 mb-6">
    <!-- AIアイコン（ChatMessageと同じスタイル） -->
    <div class="w-8 h-8 rounded-full flex-shrink-0 overflow-hidden bg-white shadow-sm flex items-center justify-center border border-gray-100 mt-0.5">
      <img :src="aiIconUrl" alt="AI" class="w-full h-full object-cover" />
    </div>
    <div class="flex-1 max-w-[720px]">
      <!-- 思考中ラベル -->
      <div class="flex items-center gap-2 mb-2">
        <span class="text-[13px] text-gray-400 font-medium">考えています</span>
        <div class="flex gap-1">
          <span class="w-1.5 h-1.5 bg-[#37acdb] rounded-full animate-bounce" style="animation-delay: 0ms" />
          <span class="w-1.5 h-1.5 bg-[#37acdb] rounded-full animate-bounce" style="animation-delay: 150ms" />
          <span class="w-1.5 h-1.5 bg-[#37acdb] rounded-full animate-bounce" style="animation-delay: 300ms" />
        </div>
        <span class="text-[12px] text-gray-300 ml-1">{{ elapsed }}秒</span>
      </div>
      <!-- スケルトン行 -->
      <div class="space-y-2.5 animate-pulse">
        <div class="h-3 bg-gray-100 rounded-full w-full" />
        <div class="h-3 bg-gray-100 rounded-full w-[88%]" />
        <div class="h-3 bg-gray-100 rounded-full w-[72%]" />
        <div class="h-3 bg-gray-100 rounded-full w-[92%]" />
        <div class="h-3 bg-gray-100 rounded-full w-[60%]" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

defineProps({
  aiIconUrl: {
    type: String,
    default: '/img/common/ai_img.svg',
  },
});

const elapsed = ref(0);
let timer = null;

onMounted(() => {
  timer = setInterval(() => {
    elapsed.value++;
  }, 1000);
});

onUnmounted(() => {
  clearInterval(timer);
});
</script>
